export const LOGO_URL = "/logo-silver.png";

export const CLINIC_WHATSAPP = "525570466065";

export const CLINIC_LOCATION_URL =
  "https://www.google.com/maps/search/Centro+M%C3%A9dico+Dr.+Neftali+Unidad+Tepotzotl%C3%A1n";

export const CLINIC_WEBSITE_URL = "https://drjairofranco.com.mx";

export const STATUS_META = {
  pendiente: { label: "Pendiente", bg: "#FEF3C7", fg: "#92400E", dot: "#D97706" },
  confirmada: { label: "Confirmada", bg: "#DBEAFE", fg: "#1E40AF", dot: "#2563EB" },
  asistio: { label: "Asistió", bg: "#DCFCE7", fg: "#166534", dot: "#16A34A" },
  cancelada: { label: "Cancelada", bg: "#FEE2E2", fg: "#991B1B", dot: "#DC2626" },
  reagendada: { label: "Reagendada", bg: "#EDE9FE", fg: "#5B21B6", dot: "#7C3AED" },
  no_asistio: { label: "No asistió", bg: "#F3F4F6", fg: "#374151", dot: "#6B7280" },
  pendiente_anticipo: { label: "Pendiente de anticipo", bg: "#FFF4E5", fg: "#B45309", dot: "#F59E0B" },
  pago_en_revision: { label: "Pago en revisión", bg: "#E7F0FB", fg: "#1D4ED8", dot: "#3B82F6" },
  reserva_vencida: { label: "Reserva vencida", bg: "#FEE2E2", fg: "#991B1B", dot: "#DC2626" },
};

export const TIPO_META = {
  primera: { label: "Primera consulta", color: "#2E6CA4", bg: "#E8F0F8" },
  subsecuente: { label: "Subsecuente", color: "#0E7490", bg: "#E0F2F4" },
};

export const DURATIONS = [15, 20, 30, 45, 60];

export const CATEGORIAS = [
  { key: "control_prenatal", label: "Control prenatal", color: "#DB2777", bg: "#FDE7F0", border: "#F0A8C6" },
  { key: "ginecologica", label: "Consulta ginecológica", color: "#2E6CA4", bg: "#E8F0F8", border: "#A9C6E2" },
  { key: "checkup_anual", label: "Check up anual", color: "#0D9488", bg: "#CCFBF1", border: "#7FE0D2" },
  { key: "climaterio", label: "Climaterio o menopausia", color: "#9333EA", bg: "#F3E8FF", border: "#D2A8F5" },
];

export const CATEGORIA_META = {
  control_prenatal: { label: "Control prenatal", color: "#DB2777", bg: "#FDE7F0" },
  ginecologica: { label: "Consulta ginecológica", color: "#2E6CA4", bg: "#E8F0F8" },
  checkup_anual: { label: "Check up anual", color: "#0D9488", bg: "#CCFBF1" },
  climaterio: { label: "Climaterio o menopausia", color: "#9333EA", bg: "#F3E8FF" },
  otro: { label: "Otro", color: "#6B7280", bg: "#F3F4F6" },
};

export const DAYS = [
  "Lunes",
  "Martes",
  "Miércoles",
  "Jueves",
  "Viernes",
  "Sábado",
  "Domingo",
];

export const ROLE_LABEL = {
  medico: "Médico",
  recepcion: "Recepción Clínica Dr Neftali",
  paciente: "Paciente",
};

export function fmtDateLong(dateStr) {
  const d = new Date(dateStr + "T00:00:00");
  return d.toLocaleDateString("es-MX", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}

export function fmtDateShort(dateStr) {
  const d = new Date(dateStr + "T00:00:00");
  return d.toLocaleDateString("es-MX", { day: "numeric", month: "short" });
}

export function todayStr() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(
    d.getDate()
  ).padStart(2, "0")}`;
}

export function addDaysStr(dateStr, n) {
  const d = new Date(dateStr + "T00:00:00");
  d.setDate(d.getDate() + n);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(
    d.getDate()
  ).padStart(2, "0")}`;
}

export function waLink(phone, message) {
  const digits = (phone || "").replace(/\D/g, "");
  return `https://wa.me/${digits}?text=${encodeURIComponent(message)}`;
}

const CLINIC = "Consultorio Dr. Jairo Franco (Ginecología y Obstetricia)";

export function confirmMsg(name, dateStr, time) {
  return `Hola ${name || ""}, le confirmamos su cita en el ${CLINIC} para el ${fmtDateLong(
    dateStr
  )} a las ${time} hrs. Por favor responda este mensaje para confirmar su asistencia. ¡Gracias!`;
}

export function reminderMsg(name, dateStr, time, when) {
  const cuando = when === "prev" ? "MAÑANA" : "HOY";
  return `Hola ${name || ""}, le recordamos que tiene cita ${cuando} ${fmtDateLong(
    dateStr
  )} a las ${time} hrs en el ${CLINIC}. Si necesita reagendar o cancelar, por favor avísenos. ¡Le esperamos!`;
}

export function clinicHelpLink() {
  return waLink(
    CLINIC_WHATSAPP,
    "Hola, no cuento con correo electrónico o requiero otro horario para mi cita con el Dr. Jairo Franco. ¿Me pueden ayudar a agendar?"
  );
}

export function clinicNotifyLink(name, dateStr, time, phone, tipo) {
  const tipoLabel = tipo === "subsecuente" ? "Subsecuente" : "Primera consulta";
  const msg = `Nueva cita agendada en el Consultorio Dr. Jairo Franco:
- Paciente: ${name || "-"}
- Teléfono: ${phone || "-"}
- Fecha: ${fmtDateLong(dateStr)}
- Hora: ${time} hrs
- Tipo: ${tipoLabel}`;
  return waLink(CLINIC_WHATSAPP, msg);
}

export function patientConfirmLink(name, dateStr, time, phone) {
  const msg = `Hola ${name || ""}, ¡tu cita en el ${CLINIC} ha quedado registrada! 📅

- Fecha: ${fmtDateLong(dateStr)}
- Hora: ${time} hrs

Por favor conserva este mensaje como confirmación. Si necesitas reagendar o cancelar, escríbenos. ¡Te esperamos!`;
  return waLink(phone, msg);
}

export function prenatalInviteLink(name, phone) {
  const msg = `Hola ${name || ""}, le saludamos del ${CLINIC}. Notamos que ya es momento de su siguiente control prenatal. 🤰

¿Le gustaría agendar su próxima cita? Puede responder este mensaje o reservar en línea. ¡Cuidemos juntos su embarazo!`;
  return waLink(phone, msg);
}

// --- Fase 5: WhatsApp asistido para anticipos ---
export function reservaCreatedMsg(appt, pay) {
  const bank = (pay && pay.bank) || {};
  const mins = (pay && pay.reservation_minutes) || 30;
  return `Tu horario ha sido reservado temporalmente en ${CLINIC}. 🗓️
Folio: ${appt.folio}
Servicio: ${appt.service_label || appt.categoria}
Fecha: ${fmtDateLong(appt.date)} · ${appt.time} hrs
Anticipo requerido: $${appt.deposit_amount} MXN
Referencia de pago: ${appt.payment_reference}

Datos para transferencia:
Banco: ${bank.banco || ""}
Titular: ${bank.titular || ""}
Cuenta: ${bank.cuenta || ""}
Concepto: ${bank.concepto || ""}
Referencia: ${appt.payment_reference}

Tu horario permanece reservado durante ${mins} minutos mientras realizas tu pago. DEBERÁS ENVIAR TU COMPROBANTE AL WHATSAPP 55-70-46-60-65.`;
}

export function comprobanteWhatsAppLink(appt, pay) {
  const to = (pay && pay.comprobante_whatsapp) || CLINIC_WHATSAPP;
  const msg = `Hola, envío mi comprobante de anticipo.
Folio: ${appt.folio}
Referencia: ${appt.payment_reference}
Paciente: ${appt.patient_name}
Fecha: ${fmtDateLong(appt.date)} · ${appt.time} hrs`;
  return waLink(to, msg);
}

export function paymentConfirmedLink(appt) {
  const nombre = (appt.patient_name || "").trim().split(" ")[0] || "";
  const saludo = nombre ? `Hola ${nombre}, ` : "Hola, ";
  const msg = `${saludo}en ${CLINIC} confirmamos la RECEPCIÓN de tu anticipo. ✅

¡Tu cita ha quedado CONFIRMADA! 🎉
Folio: ${appt.folio}
Fecha: ${fmtDateLong(appt.date)}
Hora: ${appt.time} hrs
Servicio: ${appt.service_label || appt.categoria}
Anticipo recibido: $${appt.deposit_amount} MXN
Saldo pendiente (se paga en consulta): $${appt.remaining_amount} MXN

Te esperamos. Si necesitas reagendar, avísanos con anticipación. ¡Gracias por tu confianza!`;
  return waLink(appt.patient_phone, msg);
}
